import React, { createContext, useState, ReactNode, useContext } from "react";

interface ScreenContextType {
  settingsCurrentScreen: any;
  setSettingsCurrentScreen: any;
}

export const SettingSidebarScreenContext = createContext<ScreenContextType>({
    settingsCurrentScreen: "",
    setSettingsCurrentScreen: () => {},
});

interface ScreenProviderProps {
  children: ReactNode;
}

export const SettingSidebarCurrentScreenProvider = ({ children }: ScreenProviderProps) => {
  const [settingsCurrentScreen, setSettingsCurrentScreen] = useState<any>("main");

  return (
    <SettingSidebarScreenContext.Provider value={{ settingsCurrentScreen, setSettingsCurrentScreen }}>
      {children}
    </SettingSidebarScreenContext.Provider>
  );
};

export const useSettingSidebarContext = (): ScreenContextType => {
  const context = useContext(SettingSidebarScreenContext);
  if (!context) {
    throw new Error("useSettingSidebarContext must be used within a SettingSidebarCurrentScreenProvider");
  }
  return context;
};
